interface CurrentProps {
  /** Автоматический (антифродовый) балл */
  riskPoints: number
  /** Ручная часть до правки: бессрочная плюс временная */
  manualChange: number
}

interface AfterChangeProps extends CurrentProps {
  /** Ручная часть после правки — null, пока в форме нет валидного числа */
  nextManualChange: number | null
}

/**
 * Текущий итоговый балл. Стоит вверху обеих модалок правки риск-балла: поля правят слагаемые,
 * а решение оператор принимает по итогу, и держать его в голове — тот самый источник путаницы,
 * на который жаловалось QA.
 */
export const RiskScorePreview = ({ riskPoints, manualChange }: CurrentProps) => (
  <div className='bg-light rounded p-4 mb-5 d-flex justify-content-between align-items-center'>
    <span className='fw-semibold text-muted'>Текущий риск-балл</span>
    <span className='fw-bold fs-5'>{riskPoints + manualChange}</span>
  </div>
)

/**
 * Итог после правки — строкой внизу формы и **только когда правка реально что-то меняет**.
 * Постоянно висящее «После изменения» рядом с текущим баллом читалось как второй показатель
 * клиента, хотя это предпросмотр ещё не сохранённого действия.
 *
 * Поведение одинаково в обеих модалках: пустое поле или значение, равное текущему, строку не
 * показывают вовсе.
 */
export const RiskScoreAfterChange = ({ riskPoints, manualChange, nextManualChange }: AfterChangeProps) => {
  if (nextManualChange === null || nextManualChange === manualChange) {
    return null
  }

  return (
    <div className='border-top mt-5 pt-4 fst-italic text-muted'>
      После изменения риск-балл станет{' '}
      <span className='fw-bold fs-5 text-primary fst-normal'>{riskPoints + nextManualChange}</span>
    </div>
  )
}
